import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import i18n from "i18next";

import { formatVehicle } from "../../../helpers/vehicleHelpers";
import Button from "../../Common/Button";
import PanelHeaderSummaryInfo from "./../../Layout/Panel/PanelHeaderSummaryInfo";

export default class Summary extends PureComponent {
  static propTypes = {
    selectedBillOfLading: PropTypes.object.isRequired,
    className: PropTypes.string,
    isMobile: PropTypes.bool,
    onSummaryButtonClick: PropTypes.func
  };
  static defaultProps = {
    className: "",
    isMobile: false,
    onSummaryButtonClick: null
  };

  render() {
    const { className, isMobile, onSummaryButtonClick, selectedBillOfLading } = this.props;
    const { carrierName, millOfOrigin = {}, shipmentId } = selectedBillOfLading;
    return (
      <div className={classNames("panel-summary", "routing__summary", className)}>
        <div className="routing__medium">
          <PanelHeaderSummaryInfo className="--flex-3" label={i18n.t("billsOfLading.bl")} value={shipmentId || "-"} />
          <PanelHeaderSummaryInfo className="--flex-3" label={i18n.t("billsOfLading.shippedFrom")} value={millOfOrigin.locationName} />
        </div>
        <div className="routing__large">
          <PanelHeaderSummaryInfo className="--flex-3" label={i18n.t("billsOfLading.carrier")} value={carrierName || "-"} />
          <PanelHeaderSummaryInfo className="--flex-3" label={i18n.t("billsOfLading.vehicle")} value={formatVehicle(selectedBillOfLading) || "-"} />
        </div>
        {isMobile && <Button className="panel-summary__close-button" icon="arrow-up-flat" onClick={onSummaryButtonClick} />}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/BillOfLading/Routing/Summary.js